import { Box } from "@mui/material";
import classes from "./LayerGroupArrow.module.css";

const LayerGroupArrow = (props) => {
  return (
    <Box sx={{height: 16, width: 16}}>
      <i
        className={`${
          props.show ? "fas fa-chevron-down" : "fas fa-chevron-right"
        } ${classes.arrow}`}
        style={props.arrowStyle}
        onClick={props.handleClick}
      />
    </Box>
  );
};

export default LayerGroupArrow;
